import { render } from "./Transfer.vue?vue&type=template&id=f1895ebc&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"

import "./Transfer.vue?vue&type=style&index=0&id=f1895ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1895ebc"]])

export default __exports__